import { useEvent } from 'hooks'

import { constant } from './constant'
import { selectors } from './selector'

export const Copy = (() => {
	const handleHandler = (handler: HTMLElement) => {
		const click = useEvent<MouseEvent>(handler, 'click')
		const id = handler.getAttribute(constant.selector.handler)

		if (!id) return
		const target = selectors.getTarget(id)

		if (!target) return
		click.register(() => {
			const value = target.getAttribute(constant.selector.value)

			if (!value) return
			window.navigator.clipboard.writeText(value)

			showSuccess(handler)
		})
	}

	const showSuccess = (handler: HTMLElement) => {
		const previousValue = handler.innerHTML
		handler.innerHTML = `<i class="fal fa-check" aria-hidden="true"></i>`

		if (previousValue === handler.innerHTML) {
			return
		}

		handler.classList.add('bg-green-500')
		setTimeout(() => {
			handler.classList.remove('bg-green-500')
			handler.innerHTML = previousValue
		}, 1500)
	}

	const initHandler = () => {
		const handler = selectors.getHandlers()

		for (let i = 0, { length } = handler; i < length; i++) {
			const h = handler[i]

			if (!h) continue
			handleHandler(h)
		}
	}

	const init = () => {
		initHandler()
	}

	return {
		init,
		constant,
		selectors,
	}
})()
